import axios from 'axios'
import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'
import querystring from 'querystring'

const STORAGE_CONTACTS_HOST = process.env.VUE_APP_STORAGE_CONTACTS_HOST
const STORAGE_CONTACTS_CODE = process.env.VUE_APP_STORAGE_CONTACTS_CODE

require('./../../security/interceptors')

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/contacts?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os contatos')
        })
}

const find = (id) => {
    return api.get(`/contacts/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o contato')
        })
}

const store = (data) => {
    return api.post('/contacts', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar o contato')
        })
}

const update = (data) => {
    return api.put(`/contacts/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o contato')
        })
}

const importer = (data) => {
    return api.post('/contacts/import', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível importar os contatos')
        })
}

const importerFile = (data) => {
    return axios.post(`${STORAGE_CONTACTS_HOST}?code=${STORAGE_CONTACTS_CODE}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível importar o arquivo')
        })
}

const destroy = (id) => {
    return api.delete(`/contacts/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir o contato')
        })
}

const search = (term) => {
    return api.get(`/contacts/search/?filter=${term}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível encontrar o contato')
        })
}

const validate = (data) => {
    return api.post(`/misc/validatecontacts`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível validar os contatos')
        })
}

const blacklist = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.put(`/contacts/blacklist?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o contato a lista de bloqueados.')
        })
}

export default {
    findAll,
    find,
    store,
    update,
    importer,
    importerFile,
    destroy,
    search,
    blacklist,
    validate
}
